/**
 ****************************************************************************************
 * My Account Order Statuses
 * V3 = MyAccount
 * Source: ZapposMyAccount/src/com/amazon/zapposmyaccount/viewmodel/OrderViewModel.java
 * Source: ZapposMyAccount/src/com/amazon/zapposmyaccount/viewmodel/LineItemViewModel.java
 ****************************************************************************************
 **/

export const DROPOFF_PENDING = 'return via ups drop-off';
export const PICKUP_SCHEDULED = 'return scheduled for pick-up';
export const PROCESSING_RETURN = 'processing return';
export const RETURNED_TO_ZAPPOS = 'returned to zappos';
export const RETURNING_TO_ZAPPOS = 'returning to zappos';

export const CS_DROPOFF_PENDING = 'DROPOFF_PENDING';
export const CS_PICKUP_SCHEDULED = 'PICKUP_SCHEDULED';
export const CS_PROCESSING_RETURN = 'PROCESSING_RETURN';
export const CS_RETURNED_TO_ZAPPOS = 'RETURNED_TO_ZAPPOS';
export const CS_RETURNING_TO_ZAPPOS = 'RETURNING_TO_ZAPPOS';
